module.exports = __webpack_public_path__ + "static/media/Icon_RightArrow.c35afa6f.svg";